module.exports = __webpack_public_path__ + "static/img/fm15.2b5b46e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm15.jpg
// module id = WyVr
// module chunks = 1